import { render, staticRenderFns } from "./Navbarbook.vue?vue&type=template&id=13b32b18&"
import script from "./Navbarbook.vue?vue&type=script&lang=js&"
export * from "./Navbarbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports